"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWeather = void 0;
var axios_1 = __importDefault(require("axios"));
var objectToQueryString_1 = require("../../../helpers/objectToQueryString");
var store_1 = require("../../../store");
function getWeather(data) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var state, userState, url, query;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, store_1.redux_store.getState()];
                case 1:
                    state = _g.sent();
                    return [4 /*yield*/, state.userState];
                case 2:
                    userState = _g.sent();
                    url = (_a = process.env.WEATHER_API) !== null && _a !== void 0 ? _a : "";
                    query = {
                        key: (_b = process.env.WEATHER_API_KEY) !== null && _b !== void 0 ? _b : "",
                        days: 10,
                        q: ((_c = data === null || data === void 0 ? void 0 : data.location) === null || _c === void 0 ? void 0 : _c.lat) && ((_d = data === null || data === void 0 ? void 0 : data.location) === null || _d === void 0 ? void 0 : _d.lon) ? "".concat((_e = data === null || data === void 0 ? void 0 : data.location) === null || _e === void 0 ? void 0 : _e.lat, ",").concat((_f = data === null || data === void 0 ? void 0 : data.location) === null || _f === void 0 ? void 0 : _f.lon) : "Gaborone",
                        aqi: false,
                        alerts: false,
                    };
                    return [4 /*yield*/, (0, axios_1.default)({
                            method: "GET",
                            url: "".concat(url, "/forecast.json").concat((0, objectToQueryString_1.objectToQueryString)(query)), //
                        })
                            .then(function (response) {
                            return response.data;
                        })
                            .catch(function (error) {
                            //// console.log(`api -> apiGet -> calls -> ${endpoint} ERROR:`, error);
                            // return this.extractErrorMessage(error);
                        })];
                case 3: return [2 /*return*/, _g.sent()];
            }
        });
    });
}
exports.getWeather = getWeather;
